import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

interface Props {
    text: string;
}

export default function HighlightBullet({ text }: Props) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box display="flex" flexDirection="row">
            <CheckCircle
                sx={{
                    color: theme.palette.highlighter.yellow,
                    marginRight: 1,
                    marginTop: isSmallScreen ? 0.75 : 0.5,
                    flexShrink: 0,
                    fontSize: isSmallScreen ? '16px' : '24px',
                }}
            />
            <Typography
                variant={isSmallScreen ? 'subtitle1' : 'h6'}
                sx={{ textWrap: 'pretty', color: '#FFF', textAlign: 'left' }}
            >
                {text}
            </Typography>
        </Box>
    );
}
